import lang from './lang';

const translations = {
  en: {
    gallery: 'GALLERY',
    experience: 'EXPERIENCE NOW',
    body1a: 'META-PARADE by HYPEBEAST, where the vision for a better future begins.',
    body1b: 'Our mission is to challenge the boundaries of modern innovation, revolutionizing the way people perceive technology through unconventional artistic expression. Drawing inspiration from our tech pioneers, META-PARADE transforms cutting-edge solutions from various areas — including sustainable communities and economic growth, and healthcare and well-being — into a series of experimental yet playful artworks.',
    body1c: 'META-PARADE is:',
    body1pt1: 'A stage that unites art with tech.',
    body1pt2: 'A platform with a vision to address and solve world problems.',
    body1pt3: 'A fertile breeding ground for creativity geared towards creating a better society.',
    body1pt4: 'A milestone marking the beginning of a brighter future, from here to a place beyond the horizon.',
    body2: 'Innovation and technology are making positive impacts on the future of our planet every day. They improve our health, drive economic growth, and foster sustainable communities. Everyone has their own interpretation as to how innovations impact our everyday lives. Join our collective force, and see which type of innovator you are!',
    subtitle3: 'THE SENTINEL',
    body3: 'Quietly observing the changes of the world from a safe distance, the Sentinel strongly believes that technology can improve our health and well-being. She’s seen pondering about how technological advancements is pushing the boundaries of healthcare and medical discoveries.',
    subtitle4: 'THE CREATIVE MIND',
    body4: 'Always striving for aesthetic perfectionism, the Creative Mind believes that technology can unleash endless possibilities and create a better community for humans and all species, including life on land and life below water.',
    subtitle5: 'THE ADVOCATE',
    body5: 'Diligently studying different plant samples, the Advocate is busy translating research into practical applications. He’s always looking for greener solutions, and visualizes a utopia where energy, wastage and emissions are reduced to sustainable levels.',
    subtitle6: 'THE TRAILBLAZER',
    body6: 'The Trailblazer can be found fixing and repairing reusable junk. She has high hopes for a sustainable economic growth through resilient infrastructure and sustainable industrialization, where everyone thrives.',
    body7a: 'We are a strong believer of uniting different talents. We have invited five digital artists – Ericbot404, Frank Nitty, Keith Lam & Dimension Plus, Steph Shue Yan Lau and Yarli Allison to create art pieces that converge our innovators’ passion and vision for a better future with art.',
    body7b: 'The prelude to META-PARADE has begun! Stay tuned as we gradually unveil the art series in August, and find out what lies beyond the horizon.',
    viewMore: 'VIEW MORE',
    backToTop: 'BACK TO TOP',
  },
  tc: {
    gallery: '畫廊',
    experience: '立即親身體驗',
    body1a: '由創新者啟發，HYPEBEAST 帶領的 META-PARADE 將向大家展現一個以堅毅及創新精神影響世界的遠大視野。',
    body1b: 'META-PARADE 會從一眾以可持續發展方針為目標的創科中汲取靈感，並以一系列充滿突破與趣味性的藝術品表達。META-PARADE 將展示一系列意想不到的創意藝術，每件作品各具特色，並以獨一無二的方式革新我們對現今科技的理解，將現代最新科技的界限再加推進。',
    body1c: 'META-PARADE 所代表的是：',
    body1pt1: '一個糅合藝術與科技的虛擬嘉年華。',
    body1pt2: '一個以為未來帶來正面影響為願景、啟迪人心的平台。',
    body1pt3: '一個孵化創意人才、激發創造力以造福社會的搖籃。',
    body1pt4: '一個標誌著我們不斷突破限制，邁向創新未來的里程碑。',
    body2: '創造力是推動整個世界潮流的重要元素，創科正是創造力和實用性兼備的展現，它能對一個城市發揮巨大且正面的作用。現今創科所包含的元素是前所未有的豐富，由科技與科學到藝術與設計，從生活模式、環境美學等不同層面作出革新，創造一個更美好的世界。',
    subtitle3: '守衛者',
    body3: '坐在戶內安靜觀察的守衛者，更重視科技實踐，讓各種發明提升人類健康，促進各年齡人群的福祉。她所代表的是對生物科技的好奇，想了解科技如何超越現有已知的醫療技術。',
    subtitle4: '創意人',
    body4: '著重美感、正在戶外畫畫的創意人，認為科技能為日常生活開闢更多想像。他所代表的是對日常生活的思考，期待科技可以更全面地修復生態環境及保育水資源。',
    subtitle5: '提倡者',
    body5: '研究著不同植物的提倡者，熱衷於宣揚環保理念。他所代表的是對可持續發展的擁護，關注推動科技於世界實現低耗能、低污染、低排放的可持續發展模式。',
    subtitle6: '開拓者',
    body6: '最後，正在維修、重整舊鐵的是一位開拓者，對尖端科技為經濟帶來繁榮充滿期盼。她所代表的是可持續經濟的渴求，希望現今科技發展令大家可以更仰賴綠色能源，擴大了新能源在社會上的應用。',
    body7a: '對於所有創新科技所帶來的機遇和挑戰，我們邀請到數位知名數碼藝術家 Ericbot404, Frank Nitty, Keith Lam & Dimension Plus, Steph Shue Yan Lau 及 Yarli Allison 與五間創科公司進行前所未見的跨界別合作，以他們角度窺視科技研發的原理及願景，並創作一系列別具意義的作品。',
    body7b: 'META-PARADE 序幕已經掀開，接下來將陸續為各位帶來一系列精心設計的藝術品及活動，大家敬請期待。',
    viewMore: '查看更多',
    backToTop: '返回頂部',
  },
  sc: {
    gallery: '画廊',
    experience: '立即亲身体验',
    body1a: '由创新者启发，Hypebeast 带领的 META-PARADE 将向大家展现一个以坚毅及创新精神影响世界的远大视野。',
    body1b: 'META-PARADE 会从一众以可持续发展方针为目标的创科中汲取灵感，并以一系列充满突破与趣味性的艺术品表达。META-PARADE 将展示一系列意想不到的创意艺术，每件作品各具特色，并以独一无二的方式革新我们对现今科技的理解，将现代最新科技的界限再加推进。',
    body1c: 'META-PARADE 所代表的是：',
    body1pt1: '一个糅合艺术与科技的虚拟嘉年华。',
    body1pt2: '一个以为未来带来正面影响为愿景、启迪人心的平台。',
    body1pt3: '一个孵化创意人才、激发创造力以造福社会的摇篮。',
    body1pt4: '一个标志着我们不断突破限制，迈向创新未来的里程碑。',
    body2: '创造力是推动整个世界潮流的重要元素，创科正是创造力和实用性兼备的展现，它能对一个城市发挥巨大且正面的作用。现今创科所包含的元素是前所未有的丰富，由科技与科学到艺术与设计，从生活模式、环境美学等不同层面作出革新，创造一个更美好的世界。',
    subtitle3: '守卫者',
    body3: '坐在户内安静观察的守卫者，更重视科技实践，让各种发明提升人类健康，促进各年龄人群的福祉。她所代表的是对生物科技的好奇，想了解科技如何超越现有已知的医疗技术。',
    subtitle4: '创意人',
    body4: '着重美感、正在户外画画的创意人，认为科技能为日常生活开辟更多想像。他所代表的是对日常生活的思考，期待科技可以更全面地修复生态环境及保育水资源。',
    subtitle5: '提倡者',
    body5: '研究著不同植物的提倡者，热衷于宣扬环保理念。他所代表的是对可持续发展的拥护，关注推动科技於世界实现低耗能、低污染、低排放的可持续发展模式。',
    subtitle6: '开拓者',
    body6: '最后，正在维修、重整旧铁的是一位开拓者，对尖端科技为经济带来繁荣充满期盼。她所代表的是可持续经济的渴求，希望现今科技发展令大家可以更仰赖绿色能源，扩大了新能源在社会上的应用。',
    body7a: '对于所有创新科技所带来的机遇和挑战，我们邀请到数位知名数码艺术家 Ericbot404, Frank Nitty, Keith Lam & Dimension Plus, Steph Shue Yan Lau 及 Yarli Allison 与五间创科公司进行前所未见的跨界别合作，以他们角度窥视科技研发的原理及愿景，并创作一系列别具意义的作品。',
    body7b: 'META-PARADE 序幕已经掀开，接下来将陆续为各位带来一系列精心设计的艺术品及活动，大家敬请期待。',
    viewMore: '查看更多',
    backToTop: '返回顶部',
  },
};

export default translations[lang];










